"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var layout_1 = require("../../layout");
var Loading_1 = __importDefault(require("../../Loading"));
var ButtonBadge_1 = __importDefault(require("./ButtonBadge"));
var ButtonIcon_1 = __importDefault(require("./ButtonIcon"));
var constants_1 = require("./constants");
var context_1 = require("./context");
var styles_1 = require("./styles");
var Button = function (_a, ref) {
    var hierarchy = _a.hierarchy, variant = _a.variant, _b = _a.size, propSize = _b === void 0 ? 'default' : _b, children = _a.children, propLoading = _a.loading, block = _a.block, destructive = _a.destructive, leadingIcon = _a.leadingIcon, leadingBadge = _a.leadingBadge, trailingIcon = _a.trailingIcon, icon = _a.icon, props = __rest(_a, ["hierarchy", "variant", "size", "children", "loading", "block", "destructive", "leadingIcon", "leadingBadge", "trailingIcon", "icon"]);
    var theme = react_1.useTheme();
    var iconOnly = !!icon;
    var internalVariant = hierarchy
        || (variant ? constants_1.VARIATNT_TO_INTERNAL_VARIANT[variant] : 'primary');
    var loading = internalVariant.startsWith('link-') ? false : propLoading;
    var size = constants_1.SIZE_TO_INTERNAL_SIZE[propSize];
    var styleFromTheme = react_2.useMemo(function () { return styles_1.getStyles(theme.name, internalVariant, size, block, destructive, iconOnly, loading); }, [internalVariant, size, block, destructive, theme.name, iconOnly, loading]);
    var content = icon ? (react_1.jsx(ButtonIcon_1.default, { icon: icon })) : (react_1.jsx(react_2.default.Fragment, null,
        leadingBadge && !leadingIcon ? react_1.jsx(ButtonBadge_1.default, null, leadingBadge) : null,
        leadingIcon ? react_1.jsx(ButtonIcon_1.default, { icon: leadingIcon }) : null,
        children,
        trailingIcon ? react_1.jsx(ButtonIcon_1.default, { icon: trailingIcon }) : null));
    return (react_1.jsx("button", __assign({ css: styleFromTheme, type: "button" }, props, { ref: ref }),
        react_1.jsx(context_1.ButtonProvider, { variant: internalVariant, size: size, disabled: props.disabled, destructive: destructive },
            react_1.jsx(layout_1.Flex, { css: {
                    opacity: loading ? 0 : 1,
                }, alignItems: "center", justifyContent: "center", gap: 8 }, content),
            loading ? (react_1.jsx(layout_1.Flex, { alignItems: "center", justifyContent: "center", style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                } },
                react_1.jsx(Loading_1.default.Spinner, { color: (destructive ? 'currentcolor' : constants_1.SPINNER_COLOR_MAP[internalVariant] || 'currentcolor'), size: constants_1.SIZE_MAP[size].spinner }))) : null)));
};
exports.default = Object.assign(react_2.forwardRef(Button), {
    Icon: ButtonIcon_1.default,
    Badge: ButtonBadge_1.default,
});
